import { useId } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./styles.module.css";

const Breadcrumb = ({ data, type }) => {
  const id = useId();

  const wrapperClasses = classNames({
    [styles.wrapper]: true,
    [styles.listingDetailMapScreen]: type === "listing-detail-map-screen",
  });

  return (
    <ul className={wrapperClasses}>
      {data?.map((item, index) => (
        <li key={`${id}+${index}`}>
          <a href={`${item.url}`}>{item.name}</a>
          <span>{index + 1 !== data.length ? ">" : null}</span>
        </li>
      ))}
    </ul>
  );
};

Breadcrumb.propTypes = {
  data: PropTypes.array,
  type: PropTypes.string,
};

export default Breadcrumb;
